import { FadeLoader } from 'react-spinners';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Container, Stack, Typography } from '@mui/material';
import Page from '../../components/Page';
import tracker from '../../api/tracker';
import CarrouselForm from '../../sections/@dashboard/carrousels/CarrouselForm';
import PrintButton from '../../components/print/PrintButton';
import CarrouselPrintTemplate from '../../sections/@dashboard/carrousels/CarrouselPrintTemplate';

// ---------------------------------------------------------------------

export default function EditCarrousel() {
  const [loading, setLoading] = useState(true);
  const { hashid } = useParams();
  const [carrousel, setCarrousel] = useState();
  const { t } = useTranslation();
  const fetchUserData = async () => {
    const response = await tracker.get(`carrousels/${hashid}`);
    setCarrousel(response.data.data);
    setLoading(false);
  };

  useEffect(() => {
    fetchUserData();
  }, [hashid]);

  return (
    <>
      <CarrouselPrintTemplate carrousel={carrousel} />
      <Page title={t('carrousel_form')}>
        <Container maxWidth="xl">
          <Stack direction="row" alignItems="center" justifyContent="space-between" flexWrap="wrap" gap={1} sx={{ mb: 4 }}>
            <Typography variant="h4" fontWeight={800} sx={{ color: '#032C65' }}>
              {t('edit_carrousel') || 'Editar Carrusel'}
            </Typography>
            {!loading && carrousel && <PrintButton />}
          </Stack>
          <Box sx={{ background: '#fff', borderRadius: 3, p: { xs: 2, md: 4 }, boxShadow: '0 1px 8px 0 rgba(3,44,101,0.07)' }}>
            {loading ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
                <FadeLoader color="#032C65" cssOverride={{ margin: '0 auto' }} loading={loading} />
              </Box>
            ) : (
              <CarrouselForm carrousel={carrousel} />
            )}
          </Box>
        </Container>
      </Page>
    </>
  );
}